import type { CanvasView } from './canvas-types';

export const WORKSPACE_ROUTE_PATTERN = /^\/(?:canvas|discover|brands|analytics|assets|heartbeat|ads-manager|ad-templates)?\/?$/;
const SECTION_PATHS: Partial<Record<CanvasView, string>> = {
  'ad-library': '/discover', brands: '/brands', analytics: '/analytics',
  assets: '/assets', heartbeat: '/heartbeat', 'ads-manager': '/ads-manager',
  'ad-templates': '/ad-templates',
};
const positiveId = (value: string | null): number | null => {
  if (!value || !/^\d+$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export function parseWorkspaceRoute(path: string, search = '') {
  const view = Object.entries(SECTION_PATHS).find(([, destination]) => destination === path.replace(/\/$/, ''))?.[0] as CanvasView | undefined;
  const params = new URLSearchParams(search);
  return { view: view ?? 'chat-only' as CanvasView, taskId: view ? null : positiveId(params.get('task')), folderId: view ? null : positiveId(params.get('folder')) };
}

export function workspaceUrl(view: CanvasView, taskId: number | null = null, folderId: number | null = null): string {
  return SECTION_PATHS[view] ?? (taskId != null ? `/canvas?task=${taskId}` : folderId != null ? `/canvas?folder=${folderId}` : '/canvas');
}
